itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    const module = this;
    let registeredPlugin = false;
    let registeredScrollTriggerPlugin = false;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    };

    const initScrollActions = function (element, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger); // eslint-disable-line
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                ScrollTrigger.clearScrollMemory(); // eslint-disable-line
                if (element.classList.contains("js-trigger-nav")) {
                    const activeName = document.querySelector(".js-active-name");

                    const setActive = function (link) {
                        links.forEach(el => el.parentNode.classList.remove("js-active"));
                        link.parentNode.classList.add("js-active");

                        if (activeName) {
                            activeName.textContent = link.textContent;
                        }
                    };

                    let links = gsap.utils.toArray(".js-trigger-nav-link"); // eslint-disable-line

                    const getHeaderHeight = function () {
                        const height = itsoftApp.commonVars.headerHeight || itsoftApp.utils.getHeaderHeight();
                        return height;
                    }

                    let mm = gsap.matchMedia();
                    let extraMenu = document.querySelector(".js-extra-menu");
                    let navHeight = 0;

                    links.forEach(a => {
                        let element = document.querySelector(a.getAttribute("href"));
                        ScrollTrigger.create({ // eslint-disable-line
                            trigger: element,
                            start: "top top+=" + (getHeaderHeight() + 6 + navHeight),
                            end: "bottom top+=" + (getHeaderHeight() + 6 + navHeight),
                            onToggle: self => self.isActive && setActive(a)
                        });
                    });
                }

                if (element.classList.contains("js-batch")) {
                    const steps = element.querySelectorAll(".js-step");

                    ScrollTrigger.batch(steps, {
                        start: "top 70%",
                        onEnter: batch => gsap.to(batch, {stagger: {
                            each: 0.3,
                            onStart: function () {
                                const self = this;
                                const target = self.targets()[0];
                                target.classList.add("js-active");
                            }
                        }})
                    })
                }
            }
        };

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    };

    module.callback = initScrollActions;
});